import { Auth } from "../utils/auth";
import { HealthCheckApi } from "./HealthCheckApi";
import Router from "../router";
import axios from "axios";

export class DashboardLicensesApi {
    healthCheck = null;
    token = null;

    constructor() {
        let auth = new Auth();
        this.token = auth.getToken();
        this.healthCheck = new HealthCheckApi();
    }

    async usersPerDay(params) {
        try {
            const response = await axios.post(
                Router.apiBaseUrl + Router.apiDashboardLicensesUsersPerDay,
                {
                    managementIds: params.managementIds,
                    trunkIds: params.trunkIds,
                    plantIds: params.plantIds,
                    companyIds: params.companyIds,
                    contractIds: params.contractIds,
                    validityFrom: params.validityFrom,
                    validityTo: params.validityTo,
                    roleIds: params.roleIds,
                    relativeDate: params.relativeDate,
                },
                {
                    headers: {
                        'authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return await this.healthCheck.checkApi(response);
        }catch(err) {
           return await this.healthCheck.checkApi(err);
        }
    }

    async UsersByRole(params) {
        try {
            const response = await axios.post(
                Router.apiBaseUrl + Router.apiDashboardLicensesUsersByRole,
                {
                    managementIds: params.managementIds,
                    trunkIds: params.trunkIds,
                    plantIds: params.plantIds,
                    companyIds: params.companyIds,
                    contractIds: params.contractIds,
                    validityFrom: params.validityFrom,
                    validityTo: params.validityTo,
                    roleIds: params.roleIds,
                    relativeDate: params.relativeDate,
                },
                {
                    headers: {
                        'authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return await this.healthCheck.checkApi(response);
        }catch(err) {
           return await this.healthCheck.checkApi(err);
        }
    }

    async UsersLastSession(params) {
        try {
            const response = await axios.post(
                Router.apiBaseUrl + Router.apiDashboardLicensesUsersLastSession,
                {
                    managementIds: params.managementIds,
                    trunkIds: params.trunkIds,
                    plantIds: params.plantIds,
                    companyIds: params.companyIds,
                    contractIds: params.contractIds,
                    validityFrom: params.validityFrom,
                    validityTo: params.validityTo,
                    roleIds: params.roleIds,
                    relativeDate: params.relativeDate,
                },
                {
                    headers: {
                        'authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return await this.healthCheck.checkApi(response);
        }catch(err) {
           return await this.healthCheck.checkApi(err);
        }
    }

    async UsersLicenses(params) {
        try {
            const response = await axios.post(
                Router.apiBaseUrl + Router.apiDashboardLicensesUsersLicenses,
                {
                    managementIds: params.managementIds,
                    trunkIds: params.trunkIds,
                    plantIds: params.plantIds,
                    companyIds: params.companyIds,
                    contractIds: params.contractIds,
                    validityFrom: params.validityFrom,
                    validityTo: params.validityTo,
                    roleIds: params.roleIds,
                    relativeDate: params.relativeDate,
                },
                {
                    headers: {
                        'authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return await this.healthCheck.checkApi(response);
        }catch(err) {
           return await this.healthCheck.checkApi(err);
        }
    }

}